import { render, staticRenderFns } from "./InfoReportCard.vue?vue&type=template&id=5ea2f305&scoped=true&"
import script from "./InfoReportCard.vue?vue&type=script&lang=js&"
export * from "./InfoReportCard.vue?vue&type=script&lang=js&"
import style0 from "./InfoReportCard.vue?vue&type=style&index=0&id=5ea2f305&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea2f305",
  null
  
)

export default component.exports